<div class="table-wrapper">
    <button class="btn ch-button insert-btn" (click)="createCategory()" *ngIf="!disableEdit">Insert</button>
    <cm-smart-table
        class="list-table"
        [headers]="tableHeaders"
        [rows]="_categories"
        (onCellAction)="onCellAction($event)"
    >
    </cm-smart-table>
</div>

<ng-template #longDescriptionTemplate let-row="row">
    <div class="table-data" [innerHTML]="row.longDescription | domSanitizer"></div>
</ng-template>
